export const ObtenerAsuntos = (idUsuario) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=asuntos&idUsuario='+idUsuario,{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ReporteFallas = (idUsuario, data) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=asuntosReporte&idUsuario='+idUsuario,{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}



export const ObtenerPrioridades = () => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=prioridades',{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const GuardarNuevoAsunto = (asunto) => {
    return new Promise((resolve, reject) => {
        console.log('asunto en funcion de guardar', asunto)
        const data = new FormData();
        data.append('cierreCarril', asunto.cierreCarril)
        data.append('descripcion', asunto.descripcion)
        data.append('fechaEsperada', asunto.fechaEsperada)
        data.append('idInstalacion', asunto.idInstalacion)
        data.append('idPrioridad', asunto.idPrioridad)
        data.append('idResponsable', asunto.idResponsable)
        data.append('idTipoServicio', asunto.idTipoServicio)
        data.append('idUsuario', asunto.idUsuario)
        data.append('idAsuntoPadre', asunto?.idAsuntoPadre ? asunto.idAsuntoPadre:0)
        data.append('datos', JSON.stringify(asunto));
        
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=agregarAsunto&idUsuario='+asunto.idUsuario,{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const SubirEvidencia = async(datos, idAvance) => {
    console.log('enviando evidencia')
    return new Promise((resolve, reject) => {
         fetch(process.env.REACT_APP_API_URL+'/subir.evidencia.php?idAvance='+idAvance, {
            method:'POST',
            body:datos
        })
        .then(response => response.json())
        .then(datos => resolve(datos))
    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
    })
}

export const GuardarAvance = (idAsunto, comentario, idUsuario, porcentajeAvance, idInstalacion) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('idAsunto',idAsunto);
        data.append('comentario',comentario);
        data.append('idUsuario',idUsuario);
        data.append('porcentajeAvance',porcentajeAvance);
        data.append('instalacionSeleccionada',idInstalacion);
        console.log('datos preparados para formulario', JSON.stringify(data, null,1))
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=agregarAvance',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ObtenerAvances = (idAsunto) => {
    return new Promise((resolve, reject) => {
        let datos = new FormData();
        datos.append('idAsunto', idAsunto);
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=avances',{
            method:'POST',
            body:datos
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ObtenerEvidencias = (avance) => {
    return new Promise((resolve, reject) => {
        let datos = new FormData();
        datos.append('idAvance', avance.IdAvance);
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=evidencias',{
            method:'POST',
            body:datos
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const EnviarComentario = (idAsunto, comentario, idUsuario) => {
    return new Promise((resolve, reject) => {
        let datos = new FormData();
        datos.append('idAsunto', idAsunto);
        datos.append('comentario', comentario);
        datos.append('idUsuario', idUsuario);
        fetch(process.env.REACT_APP_API_URL+'/asuntos.php?funcion=agregarComentario',{
            method:'POST',
            body:datos
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}